import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    snackbar: {
      show: false,
      timeout: -1,
      color: "success",
      message: null,
      onStateChange: false,
    },
  },
  getters: {},
  mutations: {
    showSnackbar(state, settings) {
      state.snackbar = {
        show: true,
        timeout: settings.timeout || 3000,
        color: settings.color || "success",
        message: settings.message || "",
        onStateChange: settings.onStateChange || false,
      };
      // setTimeout(() => (state.snackbar.show = false), settings.timeout || 3000);
    },
    hideSnackbar(state) {
      state.snackbar = {
        show: false,
      };
    },
  },
  actions: {
    throwError(_, response) {
      console.log(response)
      let errors = response.data.errors;

      console.log(errors);
      if (!errors) {
        return response.statusText;
      }
      console.log(typeof errors == "string");

      if (typeof errors == "string") return errors;
      if (Array.isArray(errors)) errors = errors[0];
      const [[key, [value]]] = Object.entries(errors);
      let splitArray = key.split("_");
      let joinedKeyString = splitArray
        .filter((item) => item !== "id")
        .join(" ");
      let keyString =
        joinedKeyString[0].toLocaleUpperCase() + joinedKeyString.slice(1);
      return `${keyString} ${value}`;
    },
  },

  modules: {},
});
